import api from '@pray/shared/utils/api';
import type { ObjectResponse } from '@pray/shared/utils/api/types/response';

import type { OrganizationFundResponse, UpdateOrganizationFundParams } from './types';

export async function updateOrganizationFund(
  organizationId: string,
  fundId: string,
  params: UpdateOrganizationFundParams
) {
  const url = `/web/studio/organizations/${organizationId}/funds/${fundId}`;

  /* eslint-disable camelcase */
  const body: Record<string, unknown> = {};

  if (params.name !== undefined) body.name = params.name;
  if (params.description !== undefined) body.description = params.description;
  if (params.isDefault !== undefined) body.default = params.isDefault;
  if (params.isEnabled !== undefined) body.is_enabled = params.isEnabled;
  /* eslint-enable camelcase */

  const response = await api.executePutRequest<ObjectResponse<OrganizationFundResponse>>(url, body);

  return response.data;
}
